import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { addressId: String, addressLabel: String }

  connect() {
    this.updateDropdownAndHideForm()
  }

  updateDropdownAndHideForm() {
    const select = document.getElementById('address_id')
    if (!select) return

    const newOption = document.createElement('option')
    newOption.value = this.addressIdValue
    newOption.text = this.addressLabelValue
    newOption.dataset.previewTarget = `preview-${this.addressIdValue}`

    const addNewOption = select.querySelector('option[value="new"]')
    if (addNewOption) {
      select.insertBefore(newOption, addNewOption)
    } else {
      select.appendChild(newOption)
    }

    select.value = this.addressIdValue

    // Hide other previews, show this one
    const previewsContainer = document.getElementById('address_previews')
    if (previewsContainer) {
      previewsContainer.querySelectorAll('[data-address-picker-target="preview"]').forEach(preview => {
        preview.classList.add('d-none')
      })
    }
    this.element.classList.remove('d-none')

    // Hide form and reset fields
    const formContainer = document.getElementById('new_address_form_container')
    if (formContainer) {
      formContainer.classList.add('d-none')
      formContainer.querySelectorAll('input[type="text"], input[type="email"]').forEach(input => {
        if (input.name !== 'address[country]') {
          input.value = ''
          input.classList.remove('is-invalid')
        }
      })
      const errorsDiv = formContainer.querySelector('#new_address_errors')
      if (errorsDiv) errorsDiv.innerHTML = ''
    }
  }
}
